module.exports = __webpack_public_path__ + "img/T3.92b3c38d.png";